module.exports = __webpack_public_path__ + "img/manuel.2eeeb169.jpg";